'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorShowChart = function EditorShowChart(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3.5 18.49l6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99z' })
  );
};
EditorShowChart = (0, _pure2.default)(EditorShowChart);
EditorShowChart.displayName = 'EditorShowChart';
EditorShowChart.muiName = 'SvgIcon';

exports.default = EditorShowChart;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/editor/show-chart.js
// module id = 1415
// module chunks = 0